import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

export interface IntroductionPageRow {
  id: string;
  slug: string;
  title_vi: string;
  title_kr?: string;
  content_vi?: string;
  content_kr?: string;
  is_published?: boolean;
  created_at?: string;
  updated_at?: string;
}

export function useIntroductionData(slug: string) {
  const [data, setData] = useState<IntroductionPageRow | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchData = async () => {
    setLoading(true);
    setError("");
    try {
      const { data: row } = await supabase
        .from("introduction_pages")
        .select("*")
        .eq("slug", slug)
        .maybeSingle();
      setData(row as IntroductionPageRow | null);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Lỗi tải dữ liệu");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [slug]);

  return { data, loading, error, refetch: fetchData };
}